const SignInStep = {
  USERNAME: 'username',
  PASSWORD: 'password',
};

export default SignInStep;
